import app from "../../libs/apiClient";
import { apiDriverApp } from "../../libs/apiDriverApp";

const { FLEETIO_ACCOUNT_TOKEN, FLEETIO_AUTH_TOKEN } = process.env;

export const loadMainVehicles = async (search) => {
    const url = 'https://secure.fleetio.com/api/v1/vehicles?paginate=false';

    try {
        const response = await fetch(url, {
            headers: {
                'Authorization': FLEETIO_AUTH_TOKEN,
                'Account-Token': FLEETIO_ACCOUNT_TOKEN,
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Error calling the API');
        }

        const data = await response.json();

        let filteredData = data;
        if (search) {
            const searchLower = search.toLowerCase();
            filteredData = data.filter(vehicle =>
                vehicle.name.toLowerCase().includes(searchLower)
            );
        }

        const formattedData = filteredData.map((vehicle) => ({
           name: vehicle.name,
           label: vehicle.name,
           id: vehicle.id,
           type:
              vehicle.vehicle_type_name &&
              (vehicle.vehicle_type_name.toLowerCase() === 'wheelchair van' ||
                 vehicle.vehicle_type_name.toLowerCase() === 'wheelchair shuttle')
                 ? 'Express Van'
                 : vehicle.vehicle_type_name,
        }));

        formattedData.sort((a, b) => a.name.localeCompare(b.name));

        formattedData.unshift({
            name: 'None',
            label: 'None',
            noVehicle: true
        });

        return { options: formattedData };

    } catch (error) {
        console.error('Error loading vehicles:', error);
        return { options: [] };
    }
};

export const loadFleetDrivers = async (search) => {
    try {
        let { data } = await apiDriverApp.get('api/hr/employees/?active_status=all');

        if (search) {
            const searchLower = search.toLowerCase();
            data = data.filter(driver =>
                driver.user.first_name.toLowerCase().includes(searchLower)
            );
        }

        const formattedData = data.map(driver => ({
            name: `${driver.user.first_name} ${driver.user.last_name}`,
            label: `${driver.user.first_name} ${driver.user.last_name}`,
            id: driver.id,
            employeeNum: driver.user.username,
            groupName: driver.station && driver.station.code,
            isTakeHome: driver.is_take_home
        }));
        formattedData.sort((a, b) => a.name.localeCompare(b.name));

        // No driver option
        const noDriverOption = {
            name: 'No Driver',
            label: 'No Driver',
            id: '0000',
            employeeNum: '0000',
            groupName: null,
            isTakeHome: true,
        };

        return { options: [noDriverOption, ...formattedData] };

    } catch (error) {
        console.error('Error loading drivers:', error);
        return { options: [] };
    }
}

export const loadServiceTasks = async () => {
   try {
      return app
         .service('/api/service_task/')
         .find({
            query: {
               $sort: { list_order: 1 },
            },
         })
         .then((data) => {
            const formattedData = data.map((task) => ({
               ...task,
               label: task.name,
               id: task._id,
            }));
            return { options: formattedData };
         })
         .catch((e) => {
            console.error('Error fetching service tasks:', e);
         });
   } catch (error) {
      console.error('Error loading drivers:', error);
      return { options: [] };
   }
};
